import { Features } from "@iloq/shared/IRootState";
import { PropsWithChildren, ReactElement } from "react";
import { useIsFeatureEnabled } from "./use-is-feature-enabled.hook";

export default function FeatureGuard({
  feature,
  defaultEnabled = true,
  children,
}: PropsWithChildren<{
  feature: keyof Features;
  /* By default feature flags must be defined as false to disable a feature,
   * but that can be switched by specifically setting defaultEnabled to false,
   * in which case missing flag -> disabled feature. */
  defaultEnabled?: boolean;
}>): ReactElement | null {
  const isEnabled = useIsFeatureEnabled(feature, defaultEnabled);

  if (!isEnabled) {
    return <></>;
  }
  return <>{children}</>;
}
